(function () {
  'use strict';
  var config = document.currentScript;
  if (!config || config.dataset.productId !== '9399197991232' || window.bbdtfUploaderAccessibility) return;
  if (!window.MutationObserver || !('inert' in HTMLElement.prototype)) return;
  window.bbdtfUploaderAccessibility = true;
  var closeLabel = config.dataset.closeLabel;
  if (!closeLabel) return;
  var ids = ['open-modal', 'kixxl-confirmation-modal', 'kixxl-error-modal'];
  var owned = new Map(), inertOwned = new Map(), returns = new Map();
  var active = null, launcher = null, resumeFocus = null, frame = 0, redirecting = false;
  var tabbableSelector = 'a[href],button,input:not([type="hidden"]),select,textarea,[tabindex],[contenteditable="true"]';

  function visible(node) {
    return !!(node && node.isConnected && !node.closest('[hidden]') &&
      getComputedStyle(node).visibility !== 'hidden' && node.getClientRects().length);
  }
  function one(selector, parent) {
    var nodes = (parent || document).querySelectorAll(selector);
    return nodes.length === 1 ? nodes[0] : null;
  }
  function setOwned(node, name, value) {
    var changes = owned.get(node);
    if (!changes) { changes = new Map(); owned.set(node, changes); }
    if (!changes.has(name)) changes.set(name, { before: node.getAttribute(name), after: value });
    else changes.get(name).after = value;
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }
  function restoreAttributes() {
    owned.forEach(function (changes, node) {
      changes.forEach(function (value, name) {
        if (node.getAttribute(name) !== value.after) return;
        if (value.before === null) node.removeAttribute(name); else node.setAttribute(name, value.before);
      });
    });
    owned.clear();
  }
  function restoreInert() {
    inertOwned.forEach(function (wasInert, node) {
      if (node.inert) node.inert = wasInert;
    });
    inertOwned.clear();
  }
  function focus(node) {
    if (!visible(node) || node.closest('[inert]') || node.disabled) return false;
    node.focus({ preventScroll: true });
    return document.activeElement === node;
  }
  function title(root) { return one('.gangify-modal-header-text', root); }
  function close(root) { return one('.gangify-modal-header > .gangify-modal-close', root); }
  function headingFocus(root) { return focus(title(root)) || focus(close(root)); }
  function release(restoreFocus) {
    var hadActive = active;
    active = null;
    restoreInert();
    restoreAttributes();
    if (restoreFocus && hadActive && document.hasFocus()) focus(launcher);
  }
  function contract(root) {
    var heading = title(root), button = close(root);
    return root.parentElement === document.body && root.classList.contains('gangify-upload-modal') &&
      heading && heading.textContent.trim() && button && button.tagName === 'DIV' &&
      (!root.hasAttribute('role') || (owned.has(root) && root.getAttribute('role') === (root.id === 'kixxl-error-modal' ? 'alertdialog' : 'dialog'))) &&
      (!button.hasAttribute('role') || (owned.has(button) && button.getAttribute('role') === 'button'));
  }
  function annotate(root) {
    var heading = title(root), button = close(root);
    var headingId = heading.id || 'bbdtf-title-' + root.id;
    if (document.getElementById(headingId) && document.getElementById(headingId) !== heading) return false;
    setOwned(heading, 'id', headingId);
    setOwned(heading, 'tabindex', '-1');
    setOwned(root, 'role', root.id === 'kixxl-error-modal' ? 'alertdialog' : 'dialog');
    setOwned(root, 'aria-labelledby', headingId);
    setOwned(root, 'data-bbdtf-uploader-managed', 'true');
    setOwned(button, 'role', 'button');
    setOwned(button, 'tabindex', '0');
    setOwned(button, 'aria-label', closeLabel);
    if (root.id === 'kixxl-error-modal') {
      var message = one('.gangify-modal-content', root);
      if (!message) return false;
      var messageId = message.id || 'bbdtf-uploader-error-message';
      if (document.getElementById(messageId) && document.getElementById(messageId) !== message) return false;
      setOwned(message, 'id', messageId);
      setOwned(root, 'aria-describedby', messageId);
    }
    return true;
  }
  function eligible() {
    var product = one('#gangify-product-id'), trigger = one('#upload-link');
    return product && product.value === '9399197991232' && trigger &&
      trigger.tagName === 'BUTTON' && one('#uploader') &&
      Array.from(document.scripts).some(function (script) {
        return script.src.includes('/kixxl-143/assets/KixxlUploader.js') || script.src.includes('/kixxl-146/assets/KixxlUploader.js');
      });
  }
  function sync() {
    frame = 0;
    var main = one('#open-modal');
    if (!main || !visible(main)) {
      release(true); returns.clear(); resumeFocus = null; return;
    }
    var library = one('#kixxl-library-modal');
    var roots = ids.map(function (id) { return one('#' + id); }).filter(visible);
    var foreign = Array.from(document.querySelectorAll('.gangify-upload-modal,.kixxl-library-modal'))
      .some(function (node) { return visible(node) && !ids.includes(node.id); });
    var innerDialog = roots.some(function (root) {
      return Array.from(root.querySelectorAll('[role="dialog"],[role="alertdialog"]')).some(visible);
    });
    var otherDialog = Array.from(document.querySelectorAll('[role="dialog"],[role="alertdialog"]'))
      .some(function (node) { return visible(node) && !roots.includes(node); });
    var version146 = Array.from(document.scripts).some(function (script) { return script.src.includes('/kixxl-146/assets/KixxlUploader.js'); });
    var unverifiedStage = version146 && (roots.some(function (root) { return root.id !== 'open-modal'; }) ||
      !visible(one('.uppy-Dashboard-AddFiles', main)) || !visible(one('.uppy-Dashboard-browse', main)) ||
      main.querySelectorAll('.uppy-Dashboard-Item').length > 0 || processing(main));
    if (!eligible() || unverifiedStage || (library && visible(library)) || foreign || innerDialog || otherDialog || !roots.every(contract)) {
      if (active && active.contains(document.activeElement)) resumeFocus = document.activeElement;
      release(false); return;
    }
    var previous = active;
    var next = roots[roots.length - 1];
    if (next !== previous && !returns.has(next)) returns.set(next, document.activeElement);
    if (!launcher) launcher = one('#upload-link');
    if (!roots.every(annotate)) { release(false); return; }
    restoreInert();
    active = next;
    Array.from(document.body.children).forEach(function (node) {
      if (node === active || ['SCRIPT', 'STYLE', 'LINK'].includes(node.tagName)) return;
      inertOwned.set(node, node.inert);
      node.inert = true;
    });
    roots.forEach(function (root) { setOwned(root, 'aria-modal', root === active ? 'true' : 'false'); });
    if (next !== previous && document.hasFocus()) {
      var returnTarget = previous && !visible(previous) ? returns.get(previous) : null;
      if (!returnTarget || !next.contains(returnTarget) || !focus(returnTarget)) {
        if (!resumeFocus || !next.contains(resumeFocus) || !focus(resumeFocus)) headingFocus(next);
      }
      resumeFocus = null;
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(sync);
  }
  function controls(root) {
    return Array.from(root.querySelectorAll(tabbableSelector)).filter(function (node) {
      return visible(node) && !node.disabled && !node.closest('[inert]') && node.tabIndex >= 0;
    });
  }
  function processing(root) {
    return Array.from(root.querySelectorAll('#gangify-loading-spinner,.kixxl-btn-spinner,#uppy-div .uppy-Dashboard-Item.is-inprogress,#uppy-div .uppy-Dashboard-Item.is-processing')).some(visible);
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('#upload-link');
    if (trigger && eligible()) launcher = trigger;
  }, true);
  document.addEventListener('keydown', function (event) {
    if (frame) { cancelAnimationFrame(frame); sync(); }
    if (!active || !visible(active) || event.defaultPrevented || event.isComposing) return;
    var button = close(active);
    if ((event.key === 'Enter' || event.key === ' ') && event.target === button) {
      event.preventDefault();
      if (!event.repeat) button.click();
      return;
    }
    if (event.key === 'Escape') {
      if (event.target.closest('select,[role="combobox"],[aria-expanded="true"]') || processing(active)) return;
      event.preventDefault(); event.stopPropagation(); button.click(); return;
    }
    if (event.key !== 'Tab') return;
    var list = controls(active), first = list[0], last = list[list.length - 1];
    if (!first) { event.preventDefault(); headingFocus(active); return; }
    var outside = !active.contains(document.activeElement);
    if (outside || (event.shiftKey && (document.activeElement === first || !list.includes(document.activeElement)))) {
      event.preventDefault(); focus(event.shiftKey ? last : first);
    } else if (!event.shiftKey && (document.activeElement === last || !list.includes(document.activeElement))) {
      event.preventDefault(); focus(first);
    }
  });
  document.addEventListener('focusin', function (event) {
    if (!active || redirecting || !document.hasFocus() || active.contains(event.target)) return;
    redirecting = true;
    if (frame) cancelAnimationFrame(frame);
    sync();
    if (active && !active.contains(document.activeElement)) headingFocus(active);
    redirecting = false;
  });
  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) {
      var nodes = [record.target].concat(Array.from(record.addedNodes || []), Array.from(record.removedNodes || []));
      return nodes.some(function (node) {
        return node.nodeType === 1 && (node.matches('#uploader,#gangify-form,.gangify-upload-modal,.kixxl-library-modal,[role="dialog"],[role="alertdialog"]') ||
          node.closest('#uploader,#open-modal,#kixxl-confirmation-modal,#kixxl-error-modal,#kixxl-library-modal'));
      });
    })) schedule();
  });
  var observerOptions = { childList: true, subtree: true, attributes: true,
    attributeFilter: ['style', 'class', 'hidden', 'id'] };
  observer.observe(document.body, observerOptions);
  window.addEventListener('pagehide', function () {
    observer.disconnect(); if (frame) cancelAnimationFrame(frame); frame = 0; release(false);
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { observer.observe(document.body, observerOptions); schedule(); }
  });
  schedule();
})();
